import { Above } from '@jetshop/ui/Breakpoints';
import { theme } from '../../Theme';
import React, {
  useRef,
  useState,
  useEffect,
  useCallback,
  useContext
} from 'react';
import { styled } from 'linaria/react';
import CartButton from '../../Cart/CartButton';
import CartFlyout from '../../Cart/CartFlyout';
import { Favourites } from '../../ProductList/Favourites';
import MobileMenu from './MobileMenu';
import MaxWidth from '../MaxWidth';
import useAuth from '@jetshop/core/components/AuthContext/useAuth';
import { Link } from 'react-router-dom';
import ChannelSelector from './ChannelSelector/ChannelSelector';
import Image from '@jetshop/ui/Image';
import logo from '../../../img/academy-logo.jpg';
import t from '@jetshop/intl';
import { ReactComponent as Logo } from '../../../svg/logo.svg';
import { CategoryMenu } from './CategoryMenu/CategoryMenu';
import { FavouriteCount } from '../../ProductList/FavouriteCount';
import ChannelContext from '@jetshop/core/components/ChannelContext';
import Search_new from './Search/Search_new';
import UspContainer from './UspContainer';
import { DrawerTrigger, DrawerTarget } from '@jetshop/ui/Modal/Drawer';
import { ReactComponent as User } from '../../../svg/fa/user_new.svg';
import { ReactComponent as MapMarker } from '../../../svg/fa/mapmarker_new.svg';
import { ReactComponent as MenuBars } from '../../../svg/fa/bars-regular.svg';
import CampaignPush from '../../Layout/CampaignPush/CampaignPush';
import { DynamicCategoryRenderer } from '../../StartPage/ContentRendererComponents/DynamicCategoryRenderer/DynamicCategoryRenderer';
import { allComponents } from '../../StartPage/ContentRendererComponents/allcomponents';
import Drawer from '@jetshop/ui/Modal/Drawer';
import { useQuery } from 'react-apollo';
import storeLocatorQuery from '../../StoreLocator/StoreLocator.gql';
import { useFavoriteStore } from '../../../contexts/FavoriteStoreContext';
import { ReactComponent as Cross } from '../../../svg/Cross.svg';
import slugify from 'slugify';

const FAVORITE_STORE_KEY = 'favorite_store';

const StyledTopBar = styled('div')`
  height: 36px;
  display: flex;
  background: #f6f6f6;
  padding: 0.1rem 2rem;
  color: ${theme.colors.black};
  flex-direction: row;
  justify-content: space-between;

  .favorite-store {
    margin-left: 1rem;
  }

  ${theme.below.xl} {
    padding: 0.1rem 0.75rem;
  }

  ${theme.below.lg} {
    padding: 0.5rem;
  }

  ${theme.below.sm} {
    display: none;
  }
`;

const TopBarRight = styled('div')`
  width: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  font-size: 11px;
  svg {
    font-size: 15px;
    margin-left: 0.2rem;
    width: 13px;
  }
  > a,
  > button {
    margin-left: 1rem;
  }
  button {
    color: #000;
  }

  .academy {
    display: inline-flex;
    align-items: center;
  }
`;

const AcademyImg = styled('div')`
  height: 15px;
  margin-left: 5px;
  width: 15px;
`;

const MainHeader = styled('main')`
  display: flex;
  justify-content: space-between;
  padding: 0 2rem;
  ${theme.below.xl} {
    padding: 0.5rem 0.75rem;
  }
  ${theme.below.lg} {
    padding: 0.5rem 1rem;
    /* border-bottom: 1px solid #235837; */
  }
`;

const IconsWrapper = styled('div')`
  display: flex;
  justify-content: ${props => (props.position ? 'flex-start' : 'flex-end')};
  align-items: center;
  gap: ${props => (props.gap ? '0.5rem' : '0.2rem')};
  flex: 1;

  .desktop-header-button {
    flex: none;
  }

  ${theme.below.lg} {
    width: 100%;
  }

  & > button,
  & > a {
    padding: 9px;
    max-width: 40px;
    ${theme.below.xl} {
      margin-left: 0;
      &:first-of-type {
        padding: 6px;
      }
    }
    ${theme.below.lg} {
      padding: 18px 6px;
      display: flex;
      margin-left: 2px;
      svg {
        display: block;
      }
    }
  }
  svg {
    font-size: 22px;
    height: 25px;
    max-width: 30px;
  }
`;

const LogoLink = styled(Link)`
  width: 15%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  flex: 1;
  ${theme.below.lg} {
    align-items: center;
  }
  svg {
    overflow: visible !important;
    width: 132px;
    ${theme.below.xl} {
      width: 100px;
    }
    ${theme.below.lg} {
      width: 106px;
    }
  }
`;

const Container = styled('header')`
  background-color: #fff;
  position: sticky;
  top: 0;
  z-index: 9999;
  border-bottom: 1px solid ${theme.colors.primary};

  a {
    text-decoration: none;
    color: inherit;

    &:hover {
      text-decoration: underline;
      color: #000;
    }
  }
`;

export const MenuButton = styled('button')`
  background: none;
  padding: 14px 6px;
  margin-left: 2px;
  margin-top: 2px;
  svg {
    width: 21px !important;
    height: 25px;
  }
`;

export const IconContainer = styled('span')`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  margin: 0;
`;

const MobileMenuArea = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const Top = styled('div')`
  width: 100%;
  display: flex;
  margin-top: 0.5rem;
`;

const Left = styled('div')`
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
`;
const Center = styled('div')`
  width: 100%;
  flex: 2;
  display: flex;
  align-items: center;
  ${theme.below.lg} {
    flex: 0;
  }
  a {
    display: block;
    width: 100%;
    text-align: center;
    overflow: visible;
  }
`;
const Right = styled('div')`
  width: 100%;
  flex: 1;
  display: flex;
  align-items: center;
`;
const Bottom = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 32px;
  margin: 0.8rem 0 0.5rem 0;
`;

const SearchButton = styled('button')`
  background: none;
  &:focus {
    outline: none;
  }
`;

const StyledMaxWidth = styled(MaxWidth)`
  overflow: visible;
`;

const HeaderOuter = styled('div')`
  ${theme.below.lg} {
    .search-wrapper {
      display: flex;
      border-bottom: 1px solid #d2d2d2;
      padding: 1rem;

      svg {
        color: #000;
        align-self: center;
        max-height: 30px;
      }

      img {
        padding: 5px;
      }

      .product-card {
        & > a {
          & > div:first-of-type {
            & > div:first-of-type {
              button {
                display: none;
              }
            }
          }
        }
      }
    }
  }

  .search-bar-wrapper {
    background: #fff;
    padding: 0.5rem 1rem 1rem 1rem;
    input {
      max-width: 350px;
      margin: 0 auto;
      display: block;
      text-align: center;
      border-bottom: 1px solid #1d5631;
    }
  }
`;

const FavoriteStoreButton = styled('button')`
  background: none;
  border: none;
  color: inherit;
  text-decoration: none;
  font-size: 11px;
  padding: 8px 0;
  margin-left: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    text-decoration: underline;
    color: #000;
  }
`;

const DrawerContent = styled.div`
  width: 100%;
  height: 100%;
  padding: 20px;
  background-color: white;
  overflow-y: auto;
`;

const DrawerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;

  h3 {
    font-size: 18px;
    margin: 0;
    font-weight: 600;
  }

  svg {
    cursor: pointer;
    width: 16px;
    height: 16px;
  }
`;

const WarehouseList = styled.div`
  display: block;
`;

const WarehouseItem = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-bottom: 1px solid #d2d2d2;

  .store-info {
    display: flex;
    flex-direction: column;
    width: 100%;
  }
`;

const StoreName = styled.div`
  font-weight: bold;
  font-size: 16px;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 4px;
`;

const StoreButton = styled(Link)`
  background: ${props => (props.primary ? '#000' : 'transparent')};
  color: ${props => (props.primary ? '#fff' : '#8e8e8e')};
  border: ${props => (props.primary ? 'none' : '1px solid #d2d2d2')};
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
  text-decoration: none;
  &:hover {
    background: ${props => (props.primary ? '#333' : '#f5f5f5')};
  }
`;

const StockCategory = styled.div`
  margin: 15px 0 5px;
  font-weight: 600;
  font-size: 16px;
  color: #000;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
`;

const DrawerWrapper = styled.div`
  & > div {
    margin-top: 100px;
    height: calc(100% - 100px);
    z-index: 9;
    ${theme.below.xl} {
      margin-top: 116px;
      height: calc(100% - 116px);
    }
    ${theme.below.lg} {
      margin-top: 92px;
      height: calc(100% - 92px);
    }
    ${theme.below.md} {
      margin-top: 136px;
      height: calc(100% - 136px);
    }
    ${theme.below.sm} {
      margin-top: 60px;
      height: calc(100% - 60px);
    }
  }
`;

const GlobalStoreSelector = () => {
  const { favoriteStore, setFavoriteStore, getAllStores } = useFavoriteStore();
  const { selectedChannel } = useContext(ChannelContext);

  const countries = {
    'B2C-sv': 'Sverige',
    SV: 'Sverige',
    'B2C-dk': 'Danmark',
    DK: 'Danmark',
    'B2C-no': 'Norge',
    NO: 'Norge',
    'B2C-fi': 'Suomi',
    FI: 'Suomi',
    EU: 'Europa',
    NL: 'Nederland'
  };

  const { data: storesData } = useQuery(storeLocatorQuery, {
    variables: {
      regionName: countries[selectedChannel.name]
    },
    skip: !countries[selectedChannel.name]
  });

  const handleSelectFavorite = storeName => {
    setFavoriteStore(storeName);
  };

  const SimpleStoreSelector = ({ hideTarget }) => {
    const sortedStores = [...getAllStores()].sort((a, b) =>
      a.name.localeCompare(b.name)
    );

    return (
      <>
        {favoriteStore && (
          <>
            <StockCategory>{t('Favorite store')}</StockCategory>
            <WarehouseItem className="favorite-store">
              <div className="store-info">
                <StoreName>{favoriteStore}</StoreName>
                <ButtonContainer>
                  <StoreButton
                    as="a"
                    href={'/stores/' + slugify(favoriteStore).toLowerCase()}
                  >
                    {t('Read more')}
                  </StoreButton>
                </ButtonContainer>
              </div>
            </WarehouseItem>
          </>
        )}

        <StockCategory>{t('All stores')}</StockCategory>
        {sortedStores
          .filter(store => store.name !== favoriteStore)
          .map(store => (
            <WarehouseItem key={store.id}>
              <div className="store-info">
                <StoreName>{store.name}</StoreName>
                <ButtonContainer>
                  <StoreButton
                    as="a"
                    href={'/stores/' + slugify(store.name).toLowerCase()}
                  >
                    {t('Read more')}
                  </StoreButton>
                  <StoreButton
                    primary
                    onClick={() => {
                      handleSelectFavorite(store.name);
                      if (hideTarget) hideTarget();
                    }}
                  >
                    {t('Choose')}
                  </StoreButton>
                </ButtonContainer>
              </div>
            </WarehouseItem>
          ))}
      </>
    );
  };

  return (
    <DrawerWrapper>
      <DrawerTarget id="header-store-selector">
        {drawer => (
          <Drawer isOpen={drawer.isOpen} right backdrop>
            <DrawerContent>
              <DrawerHeader>
                <h3>{t('Select favorite store')}</h3>
                <Cross onClick={drawer.hideTarget} />
              </DrawerHeader>
              <WarehouseList>
                <SimpleStoreSelector hideTarget={drawer.hideTarget} />
              </WarehouseList>
            </DrawerContent>
          </Drawer>
        )}
      </DrawerTarget>
    </DrawerWrapper>
  );
};

export const TopBar = () => {
  const { loggedIn } = useAuth();
  const { selectedChannel } = useContext(ChannelContext);
  const { favoriteStore } = useFavoriteStore();

  return (
    <StyledTopBar>
      <UspContainer />
      <Above breakpoint="lg">
        <TopBarRight>
          <Link to="/hooks-academy" className="academy">
            <span>Hööks Academy</span>
          </Link>

          {selectedChannel.name !== 'EU' && (
            <>
              <Link to="/login">
                {loggedIn ? t('My pages') : t('Login')} <User />
              </Link>

              {favoriteStore && (
                <DrawerTrigger id="product-store-stock-drawer">
                  {({ showTarget, hideTarget, isOpen }) => (
                    <FavoriteStoreButton
                      onClick={isOpen ? hideTarget : showTarget}
                    >
                      Favoritbutik: {favoriteStore}
                    </FavoriteStoreButton>
                  )}
                </DrawerTrigger>
              )}
            </>
          )}

          <Link to="/stores">
            {t('Find a store')}
            <MapMarker />
          </Link>
          <ChannelSelector />
        </TopBarRight>
      </Above>
    </StyledTopBar>
  );
};

function LeftHeader() {
  const { selectedChannel } = useContext(ChannelContext);
  const isLeft = true;
  return (
    <DrawerTrigger preventOverflow={true} id="menu-drawer">
      {drawer => (
        <IconsWrapper position={isLeft} gap={isLeft}>
          <MenuButton
            onClick={drawer.isOpen ? drawer.hideTarget : drawer.showTarget}
          >
            <MenuBars />
          </MenuButton>
          {selectedChannel.name !== 'EU' && (
            <div className="gmf-dropdown-profile" />
          )}
        </IconsWrapper>
      )}
    </DrawerTrigger>
  );
}

function RightHeader() {
  const { selectedChannel } = useContext(ChannelContext);
  const isLeft = false;
  return (
    <IconsWrapper position={isLeft} gap={isLeft}>
      <Above breakpoint="lg">
        {matches =>
          matches ? (
            <>
              {selectedChannel.name !== 'EU' && (
                <div className="gmf-dropdown-profile" />
              )}
              <FavouriteCount />

              <CartButton className="desktop-header-button" />
            </>
          ) : (
            <>
              <FavouriteCount />
              <CartButton className="desktop-header-button" />
            </>
          )
        }
      </Above>
    </IconsWrapper>
  );
}

export default function Header() {
  return (
    <>
      <Container>
        <TopBar />
        <HeaderOuter>
          <MainHeader>
            <Above breakpoint="lg">
              {matches =>
                matches ? (
                  <>
                    <LogoLink to="/">
                      <Logo />
                    </LogoLink>
                    <CategoryMenu />
                    <RightHeader />
                  </>
                ) : (
                  <MobileMenuArea>
                    <Top>
                      <Left>
                        <LeftHeader />
                      </Left>

                      <Center>
                        <LogoLink to="/">
                          <Logo />
                        </LogoLink>
                      </Center>

                      <Right>
                        <RightHeader />
                      </Right>
                    </Top>
                  </MobileMenuArea>
                )
              }
            </Above>
          </MainHeader>
          <Above breakpoint="lg">
            {matches => (matches ? null : <MobileMenu />)}
          </Above>
          <Search_new />
        </HeaderOuter>
      </Container>
      <CartFlyout />
      <Favourites />
      <GlobalStoreSelector />
      <DynamicCategoryRenderer
        categoryId={1963}
        rendererComponents={allComponents}
      />
    </>
  );
}
